import Container from "../core/Container"
import Heading from "../core/Heading"

export default function SectionTag({name, children}) {
    return(
        <Container bgColor="transparent" className="text-center mb-12 md:mb-16">
            <Container bgColor="transparent" className="mb-4">
                <Heading variant="h1">{name || children}</Heading>
            </Container>
            <Container className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto rounded-full"></Container>
        </Container>
    )

}